<template>
  <div class="col">
    <div id="main" class="col-main">
      <div class="row no-gutters row-main justify-content-center">
        <div class="col-12 col-lg-10 bg-white">
          <div class="row no-gutters justify-content-center">
            <div class="col-12 col-lg-9">
              <h2 class="section-title">Register your interest for the {{year}} season</h2>
            </div>

            <div class="col-12 col-lg-9">
              <!-- Text -->
              <p class="h5">
                Interested in playing for Ealing Trailfinders Cricket Club in {{year}}? <br>
                
                <br>Whether you're 5 years old and just starting your cricketing journey
                  or you are returning to the sport after a pause, there is a place 
                  here for you. Register your interest in getting involved in Cricket 
                  and we'll get back to you as soon as possible.
              </p>
              <p v-if="secretary.members_name">
                If you want to speak with a committee member you can speak directly to:
                <p>{{ secretary.title }}
                  <strong>{{ secretary.members_name }}</strong>
                  <a v-if="secretary.contact_number" v-bind:href="'tel:' + formatPhoneNumber(secretary.contact_number)"> {{ formatPhoneNumber(secretary.contact_number) }}</a>
                </p>
              </p>
            </div>

            <div class="col-12 col-lg-9 m-5">
              <b-tabs content-class="mt-3" v-model="myTabs" lazy justified>
                <b-tab title="Adults">
                  <b-form @submit="onAdultSubmit" class="w-100 mt-5">
                    <p class="text-right text-small">All fields are required</p>
                    <h6>Contact Details:</h6>

                    <b-form-group>
                      <b-form-input
                        id="formJoinUs-YourName-adults"
                        type="text"
                        placeholder="Your full name"
                        v-model="adults.name"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group>
                      <b-form-input
                        id="formJoinUs-Email-adults"
                        type="email"
                        placeholder="Email address"
                        v-model="adults.contact_email"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group>
                      <b-form-input
                        type="tel"
                        id="formJoinUs-PhoneNumber-adults"
                        placeholder="Phone number"
                        v-model="adults.number"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-checkbox
                      v-model="adultChecked"
                      name="check-button"
                      switch
                      size="lg"
                    >Send me a confirmation of receipt</b-form-checkbox>

                    <b-button
                      class="mt-3"
                      type="submit"
                      variant="success"
                      :disabled="isDisabled"
                      block
                    >Register</b-button>
                  </b-form>
                </b-tab>

                <b-tab title="Juniors">
                  <b-form @submit="onJuniorSubmit" class="w-100 mt-5">
                    <p class="text-right text-small">All fields are required</p>
                    <h6>Contact Details:</h6>

                    <b-form-group>
                      <b-form-input
                        id="formJoinUs-YourName-juniors"
                        type="text"
                        placeholder="Your full name"
                        v-model="juniors.guardian_name"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group>
                      <b-form-input
                        id="formJoinUs-Email-juniors"
                        type="email"
                        placeholder="Email address"
                        v-model="juniors.guardian_email"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group>
                      <b-form-input
                        type="tel"
                        id="formJoinUs-PhoneNumber-juniors"
                        placeholder="Phone number"
                        v-model="juniors.guardian_number"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <h6>About Child:</h6>

                    <b-form-group>
                      <b-form-input
                        id="formJoinUs-YourChildName-juniors"
                        type="text"
                        placeholder="Child's full name"
                        v-model="juniors.childs_name"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group>
                      <b-form-input
                        type="number"
                        id="formJoinUs-ChildAge-juniors"
                        placeholder="Child's age"
                        v-model="juniors.childs_age"
                        required
                      ></b-form-input>
                    </b-form-group>

                    <b-form-checkbox
                      v-model="juniorChecked"
                      name="check-button"
                      switch
                      size="lg"
                    >Send me a confirmation of receipt</b-form-checkbox>

                    <b-button
                      class="mt-3"
                      type="submit"
                      variant="success"
                      :disabled="isDisabled"
                      block
                    >Register</b-button>
                  </b-form>
                </b-tab>

                <div
                  v-if="showSuccess"
                  class="cust-alert cust-alert-success p-2"
                  role="alert"
                >You have successfully submitted your details.</div>
                <div v-if="showFail" class="cust-alert cust-alert-danger p-2" role="alert">
                  There has been an error submitting your details, please try again later or email
                  cricket@ealingtcc.com.
                </div>
                <div v-if="showCustomerFail" class="cust-alert cust-alert-danger p-2" role="alert">
                  There has been an error emailing a receipt of your data, please email
                  cricket@ealingtcc.com if you need a confirmation email.
                </div>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { postEmail, fetchCommitteeMembers } from "@/services/api";
import formatPhoneNumber from "@/utils/formatPhoneNumber";
import EventBus from '../eventBus'

export default {
  data() {
    return {
      year: "",
      myTabs: 0,
      adults: {},
      juniors: {},
      adultChecked: false,
      juniorChecked: false,
      isDisabled: false,
      showSuccess: false,
      showFail: false,
      showCustomerFail: false,
      secretary: {},
    };
  },
  mounted() {
    if (this.$route.query.form === "adult") this.myTabs = 0;
    if (this.$route.query.form === "junior") this.myTabs = 1;

    EventBus.$on("get-year", (year) => {
      this.year = year
    })

    this.fetchSecretary();
  },
  methods: {
    fetchSecretary() {
      fetchCommitteeMembers().then((members) => {
        this.secretary =
          (members || []).find(
            (member) => member.title && member.title.toLowerCase().includes("secretary")
          ) || {};
      });
    },
    formatPhoneNumber,
    onAdultSubmit(evt) {
      evt.preventDefault();
      this.isDisabled = true;

      let emailBody = "";
      emailBody +=
        "Name: " +
        this.adults.name +
        "<br />" +
        "Email: " +
        this.adults.contact_email +
        "<br />" +
        "Phone Number: " +
        this.adults.number;

      let options = {
        send_to: "cricket@ealingtcc.com",
        cc: "wendy.langan@ealingtcc.com",
        subject: "New Adult Registration Request",
        email_body: emailBody,
        from:
          "Ealing Trailfinders Cricket Club <do-not-reply@trailfinders.com>",
        originator_system: "cricketAdultRegistrationInternal",
        inc_headers_footers: false,
        version: "1",
        ieBooking: false,
        inc_awards: false,
      };

      postEmail(options).then((response) => {
        if (response === true) this.showSuccess = true;
        else this.showFail = true;
      });

      if (this.adultChecked === true) {
        let emailBody = "";
        emailBody +=
          "Thanks, you have successfully submitted a registration request, a member of the team will be in touch soon." +
          "<br />" +
          "<br />" +
          "Name: " +
          this.adults.name +
          "<br />" +
          "Email: " +
          this.adults.contact_email +
          "<br />" +
          "Phone Number: " +
          this.adults.number;

        let clientOptions = {
          send_to: this.adults.contact_email,
          subject: "Your Ealing Trailfinders Cricket Club Registration Request",
          email_body: emailBody,
          from:
            "Ealing Trailfinders Cricket Club <do-not-reply@trailfinders.com>",
          originator_system: "cricketAdultRegistrationExternal",
          inc_headers_footers: false,
          version: "1",
          ieBooking: false,
          inc_awards: false,
        };

        postEmail(clientOptions).then((response) => {
          if (response !== true) this.showCustomerFail = true;
        });
      }
    },
    onJuniorSubmit(evt) {
      evt.preventDefault();
      this.isDisabled = true;

      let emailBody = "";
      emailBody +=
        "Guardian's Name: " +
        this.juniors.guardian_name +
        "<br />" +
        "Guardian's Email: " +
        this.juniors.guardian_email +
        "<br />" +
        "Guardian's Phone Number: " +
        this.juniors.guardian_number +
        "<br />" +
        "Child's Name: " +
        this.juniors.childs_name +
        "<br />" +
        "Child's Age: " +
        this.juniors.childs_age;

      let options = {
        send_to: "cricket@ealingtcc.com",
        subject: "New Junior Registration Request",
        email_body: emailBody,
        from:
          "Ealing Trailfinders Cricket Club <do-not-reply@trailfinders.com>",
        originator_system: "cricketJuniorRegistrationInternal",
        inc_headers_footers: false,
        version: "1",
        ieBooking: false,
        inc_awards: false,
      };

      postEmail(options).then((response) => {
        if (response === true) this.showSuccess = true;
        else this.showFail = true;
      });

      if (this.juniorChecked === true) {
        let emailBody = "";
        emailBody +=
          "Thanks, you have successfully submitted a registration request, a member of the team will be in touch soon." +
          "<br />" +
          "<br />" +
          "Name: " +
          this.juniors.guardian_name +
          "<br />" +
          "Email: " +
          this.juniors.guardian_email +
          "<br />" +
          "Phone Number: " +
          this.juniors.guardian_number +
          "<br />" +
          "Child's Name: " +
          this.juniors.childs_name +
          "<br />" +
          "Child's Age: " +
          this.juniors.childs_age;

        let clientOptions = {
          send_to: this.juniors.guardian_email,
          subject: "Your Ealing Trailfinders Cricket Club Registration Request",
          email_body: emailBody,
          from:
            "Ealing Trailfinders Cricket Club <do-not-reply@trailfinders.com>",
          originator_system: "cricketJuniorRegistrationExternal",
          inc_headers_footers: false,
          version: "1",
          ieBooking: false,
          inc_awards: false,
        };

        postEmail(clientOptions).then((response) => {
          if (response !== true) this.showCustomerFail = true;
        });
      }
    },
  },
};
</script>

<style scoped>
div .cust-alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}

div .cust-alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

div .cust-alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 1px solid;
  border-radius: 0.25rem;
  text-align: center;
}
</style>
